<template>
  <div class="upload-container">
    <!-- 上传组件 -->
    <el-upload
      v-if="isViewMode"
      ref="upload"
      :action="fileUploadUrl"
      :data="recruitUploadData"
      :headers="recruitUploadHeader"
      list-type="picture-card"
      :file-list="fileList"
      :limit="maxCount"
      :on-exceed="handleExceed"
      :before-upload="beforeUpload"
      :on-remove="handleRemove"
      :on-success="handleSuccess"
      :class="{ 'hide-upload': shouldHideUpload }"
    >
      <i class="el-icon-plus"></i>
      <div slot="file" slot-scope="{ file }" class="custom-upload-item">
        <img
          class="image-thumbnail"
          :src="dialogImageUrl"
          :alt="file.name"
          :style="imageStyle"
        />
        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview" @click="handlePreview(file)">
            <i class="el-icon-zoom-in"></i>
          </span>
          <span class="el-upload-list__item-delete" @click="handleRemove(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>

    <!-- 只读模式下的图片展示 -->
    <div v-else class="view-mode-images">
      <div v-if="!dialogImageUrl" style="font-size:10px;color:#606266">未上传</div>
      <div v-else class="view-image-item">
        <div class="image-container">
          <el-image 
            class="view-image"
            :preview-src-list="[dialogImageUrl]"
            :src="dialogImageUrl" >
          </el-image>
          <!-- <img class="view-image" :src="dialogImageUrl" @click="handlePreview(file)" /> -->
        </div>
      </div>
    </div>

    <!-- 图片预览对话框 -->
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import base from "./../js/base";

export default {
  mixins: [base],
  name: "imageUploader",
  props: {
    // 初始文件列表
    initialFiles: {
      type: Array,
      default: () => [],
    },
    // 是否为查看模式
    isViewMode: {
      type: Boolean,
      default: false,
    },
    // 最大上传数量
    maxCount: {
      type: Number,
      default: 1,
    },
    // 允许的文件类型
    accept: {
      type: String,
      default: "image/jpeg,image/png,image/gif",
    },
    // 文件大小限制(MB)
    maxSize: {
      type: Number,
      default: 5,
    },
    imageUrl: {
      type: String,
      default: "",
    },
    idField: {
      type: String,
      default: "",
    },
    urlField: {
      type: Array,
      default: "",
    },
    // 新增图片显示控制参数
    imageFit: {
      type: String,
      default: "contain", // 可选: contain, cover, fill, none, scale-down
    },
    imageWidth: {
      type: String,
      default: "100%",
    },
    imageHeight: {
      type: String,
      default: "100%",
    },
    remoteFiles: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    imageStyle() {
      return {
        "object-fit": this.imageFit,
        width: this.imageWidth,
        height: this.imageHeight,
      };
    },
    shouldHideUpload() {
      let shouldHideUpload = this.fileList.length >= this.maxCount;
      return shouldHideUpload;
    },
  },
  data() {
    return {
      fileList: [],
      // viewMode: true,
      fileUploadUrl: this.$uploadImg,
      dialogVisible: false,
      dialogImageUrl: "",
      imageIdField: "",
      imageUrlField: "",
      fileId: "",
      isRemoved: false,
    };
  },
  watch: {
    initialFiles: {
      immediate: true,
      handler(files) {
        if (files && files.length > 0) {
          this.fileList = files.map((file) => ({
            name: file.name,
          }));
        }
      },
    },
    remoteFiles: {
      deep: true,
      handler(newVal) {
        this.fileList = newVal.map((url) => ({
          url,
          status: "success",
        }));
      },
    },
    imageUrl: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          // 当传入的图片地址变化时更新
          this.dialogImageUrl = newVal;
          // 清空旧文件列表，避免重复添加
          this.fileList = [];
          const remoteFile = {
            url: newVal,
            status: "success",
          };
          this.fileList.push(remoteFile);
        }
      },
    },
  },
  mounted() {
    // this.viewMode = this.isViewMode;
    this.dialogImageUrl = this.imageUrl;
  },
  methods: {
    // 文件超出数量限制
    handleExceed() {
      this.$message.warning(`最多只能上传 ${this.maxCount} 张证件照`);
    },

    // 上传前校验
    beforeUpload(file) {
      const isAccept = this.accept.split(",").includes(file.type);
      const isLtSize = file.size / 1024 / 1024 < this.maxSize;

      if (!isAccept) {
        this.$message.error(`只能上传 ${this.accept} 格式的图片`);
      }
      if (!isLtSize) {
        this.$message.error(`图片大小不能超过 ${this.maxSize}MB`);
      }

      return isAccept && isLtSize;
    },

    // 文件状态改变
    handleChange(file, fileList) {
      // 检查文件数量
      if (fileList.length > this.maxCount) {
        fileList = fileList.slice(0, this.maxCount);
      }

      // // 生成预览URL
      // if (file.raw) {
      //   file.url = URL.createObjectURL(file.raw)
      // }

      this.fileList = fileList;
      //this.emitChange()
    },
    // 触发remove事件
    emitRemove(key) {
      this.$emit("remove", key);
    },
    // 删除文件
    handleRemove(file) {
      if (this.maxCount == 1) {
        this.fileList = [];
      } else {
        this.fileList = this.fileList.filter((item) => item.url !== file.url);
      }
      this.emitRemove(this.urlField);
    },

    // 预览图片
    handlePreview(file) {
      // this.dialogImageUrl = this.imageUrl;
      this.dialogVisible = true;
    },

    // 获取上传的文件(用于表单提交)
    getUploadFiles() {
      return this.fileList.filter((file) => file.raw);
    },

    // 清空文件列表
    clearFiles() {
      this.fileList = [];
    },

    // 触发success事件
    emitSuccess(fileId, fileUrl, idField, urlField) {
      console.log(
        fileId,
        fileUrl,
        idField,
        urlField,
        "fileId, fileUrl, idField, urlField"
      );
      this.$emit("success", fileId, fileUrl, idField, urlField);
    },
    // 文件上传成功后处理（存入对应字段）
    handleSuccess(response, file, fileList) {
      if (response.result.isSuccess) {
        let fileId = response.data.fileId + "." + response.data.ext;
        let fileUrl = this.$linkUrl + response.data.fileId + "." + response.data.ext;

        if (this.maxCount == 1 || !this.fileList) {
          this.fileList = [];
        }
        const remoteFile = {
          url: fileUrl,
          status: "success",
        };
        this.dialogImageUrl = fileUrl;
        this.fileList.push(remoteFile);
        this.emitSuccess(fileId, fileUrl, this.idField, this.urlField[0]);
      }
    },
  },
  generateUID() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
  },
};
</script>

<style scoped>
.image-uploader-container {
  margin: 20px 0;
}

/* 缩略图容器样式 */
::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 148px;
  height: 148px;
}

/* 预览容器样式 */
.preview-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.preview-image {
  max-width: 100%;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

/* 操作按钮样式 */
::v-deep .el-upload-list__item-actions {
  background-color: rgba(0, 0, 0, 0.5);
}

::v-deep .el-upload-list__item-actions span {
  color: #fff;
  margin: 0 5px;
}
.hide-upload >>> .el-upload--picture-card {
  display: none;
}
.view-mode-images .view-image {
  width: 146px;
  height: 146px;
}
</style>



// WEBPACK FOOTER //
// src/pages/recruit/officeSaff/component/imageUploader.vue